export default "__VITE_ASSET__BcIo4V$W__"